import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Pillars from "./components/Pillars";
import Footer from "./components/Footer";
import Alumni from "./components/Alumni";
import Videos from "./components/Videos";
import AboutUs from "./components/About-us";
import News from "./components/News";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import MsgFromRector from "./components/MsgFromRector";
import Staff from "./components/Staff";
import Olevel from "./components/O-level";
import SpiritualActivities from "./components/Spiritual-Sessions";
import Games from "./components/games&sports";
import EnvironmentalActivities from "./components/Env-Activities";
import AgriculturalActivities from "./components/Agricultural";
import Dispensary from "./components/Dispensary";
import ContactUs from "./components/ContactUs";
import Alevel from "./components/A-level";
import OlevelAdmission from "./components/OlevelAdmission";
import AlevelAdmission from "./components/AlevelAdmission";
import FormationAdmission from "./components/FormationAdmission";
import Organization from "./components/Organization";
import History from "./components/HistoryOfSeminary";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Images from "./components/ImageLists";
import TechnicalSkills from "./components/TechnicalSkills";
import "./i18n";
import NotFound from "./components/NotFound";
import Users from "./components/Users";
import ProtectedRoute from "./ProtectedRoute";
import Developer from "./components/Developer";
import Wawata from "./components/Wawata";
import Team from "./components/Team";
import ScrollToTop from "./components/ScrollToTop";



const Layout = ({ children }) => {
  const location = useLocation();
  
  const noLayoutPaths = [
    "/login",
    "/dashboard",
    "/developer",
    "/users",
    "/images",
    "/not-found"
  ];

  // Check if current path is in noLayoutPaths or is a non-existent route (showing NotFound)
  const hideLayout =
    noLayoutPaths.includes(location.pathname) ||
    ![
      "/",
      "/alumni",
      "/news",
      "/about-us",
      "/msg",
      "/staff",
      "/o-level",
      "/a-level",
      "/spiritual",
      "/works",
      "/work",
      "/games",
      "/dispensary",
      "/contact",
      "/o-level-admission",
      "/a-level-admission",
      "/formation-admission",
      "/organization",
      "/history",
      "/team",
      "/wawata",
      "/services",
      "/pillars",
      "/gallery"
    ].includes(location.pathname);

  return (
    <>
      {!hideLayout && <Navbar />}
      <div className="w-full min-h-screen">{children}</div>
      {!hideLayout && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          {/* Main home route */}
          <Route path="/" element={
            <>
              <Home />
              <Videos />
              <div className="max-w-7xl mx-auto pt-1 lg:px-7 sm:px-20">
                <Services />
              </div>
              <Pillars />
              <News />
              <TechnicalSkills />
              <Wawata />
              
              <Gallery />
             {/*  <Team />  */}
            </>
          } />

          <Route path="/alumni" element={<Alumni />} />
          <Route path="/news" element={<News />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/msg" element={<MsgFromRector />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/o-level" element={<Olevel />} />
          <Route path="/a-level" element={<Alevel />} />
          <Route path="/spiritual" element={<SpiritualActivities />} />
          <Route path="/works" element={<EnvironmentalActivities />} />
          <Route path="/work" element={<AgriculturalActivities />} />
          <Route path="/games" element={<Games />} />
          <Route path="/dispensary" element={<Dispensary />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/o-level-admission" element={<OlevelAdmission />} />
          <Route path="/a-level-admission" element={<AlevelAdmission />} />
          <Route path="/formation-admission" element={<FormationAdmission />} />
          <Route path="/organization" element={<Organization />} />
          <Route path="/history" element={<History />} />
          <Route path="/wawata" element={<Wawata />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pillars" element={<Pillars />} />
          <Route path="/gallery" element={<Gallery />} />
          

          {/* Login Route (No Navbar or Footer) */}
          <Route path="/login" element={<Login />} />
          <Route path="/developer" element={<Developer />} />
          <Route path="/dashboard" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute> <Users /> </ProtectedRoute>} />
          <Route path="/not-found" element={<NotFound />} />
          <Route path="/images" element={<Images />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
